import { render, staticRenderFns } from "./CustomPageHeader.vue?vue&type=template&id=fd307184&"
import script from "./CustomPageHeader.vue?vue&type=script&lang=js&"
export * from "./CustomPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports